import {
    SET_DADOS_INICIAIS_DADOS_BANCARIOS,
    LOADING_DADOS_INICIAIS_DADOS_BANCARIOS,
    ERROR_DADOS_INICIAIS_DADOS_BANCARIOS,

    HANDLE_CHANGE_DADOS_BANCO,
    HANDLE_CHANGE_DADOS_TIPO_CONTA,

    SET_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,
    LOADING_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,
    ERROR_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,

    SET_DADOS_INICIAIS_DADOS_TYPEHEADER_BANCO,

    CHANGE_DADOS_INICIAIAS_DADOS_BANCARIOS_VALUE_FORM
} from './types';
  
  const initialState = { 
    dropdownBancoList: [],
    loadingDadosBancarios: false,
    errorDadosBancarios: null,
    typeaheaderBancoList: [],
    dropdownTipoContaList: [],
    loadingTipoConta: false,
    errorTipoConta: null,

    formDadosBancarios: {
      dadosBancarios_Banco: '',
      dadosBancarios_TipoConta: '',
      dadosBancarios_Agencia: '',
      dadosBancarios_Conta: ''
    },
  }
  
  
  export default function dadosBancarioReducer(state = initialState, action) {
    switch (action.type) {

    case SET_DADOS_INICIAIS_DADOS_BANCARIOS:
      return { ...state, dropdownBancoList: action.payload }
    case SET_DADOS_INICIAIS_DADOS_TYPEHEADER_BANCO: 
      return { ...state, typeaheaderBancoList: action.payload }
    case LOADING_DADOS_INICIAIS_DADOS_BANCARIOS:
        return { ...state, loadingDadosBancarios: action.payload }
    case ERROR_DADOS_INICIAIS_DADOS_BANCARIOS:
      return { ...state, errorDadosBancarios: action.payload }

    case SET_DADOS_INICIAIS_TIPO_CONTA_BANCARIA:
        return { ...state, dropdownTipoContaList: action.payload }
    case LOADING_DADOS_INICIAIS_TIPO_CONTA_BANCARIA:
        return { ...state, loadingDadosBancarios: action.payload }
    case ERROR_DADOS_INICIAIS_TIPO_CONTA_BANCARIA:
        return { ...state, errorDadosBancarios: action.payload }

    case HANDLE_CHANGE_DADOS_BANCO:
        return { ...state, formDadosBancarios: { ...state.formDadosBancarios, dadosBancarios_Banco: action.payload }}
    case HANDLE_CHANGE_DADOS_TIPO_CONTA:
        return { ...state, formDadosBancarios: { ...state.formDadosBancarios, dadosBancarios_TipoConta: action.payload }}
    case CHANGE_DADOS_INICIAIAS_DADOS_BANCARIOS_VALUE_FORM:
        return { ...state, formDadosBancarios: action.payload }

      default:
        return state
    }
  }